import { createContext, useContext } from 'react';

/**
 * The auth context and its hook live apart from the provider component: a
 * module that exports both a component and a hook cannot be hot-reloaded in
 * isolation, and the linter flags it for that reason.
 */
export const AuthContext = createContext({});

export function useAuth() {
    return useContext(AuthContext);
}
